import {EmptyState} from "../../../../empty-state";

export function ServiceOrderListEmptyState() {
  return (
    <div>
      <EmptyState message="You do not have any customer orders at the moment" />
    </div>
  );
}
